export type WorkListBase = '/fanfics' | '/originals';

export function resolveWorkPathPrefix(type?: string | null): WorkListBase {
  return type === 'original' ? '/originals' : '/fanfics';
}

export function resolveFanficWorkListBase(
  pathname: string | null,
  detailPathPrefix?: WorkListBase,
  type?: 'fanfic' | 'original',
): WorkListBase {
  if (detailPathPrefix) return detailPathPrefix;
  const normalized = (pathname ?? '').replace(/\/$/, '') || '/';
  if (normalized === '/originals') return '/originals';
  if (type === 'original') return '/originals';
  return '/fanfics';
}
